import * as types from '../constants/ActionTypes';
import { setFieldsDetail } from '../../lib/emailUtil';

const initialState = {
  isLoading: false,
  error: false,
  display: false,
  topicName: '',
  fields: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SELECT_TOPIC_L1:
      return { ...state, topicName: action.payload.topic_name };
    case types.SELECT_TOPIC_L2:
      return {
        ...state, topicName: state.topicName, subTopicName: action.payload.topic_name, fieldPrefix: action.payload.topic_id, fields: [],
      };
    case types.SELECT_TOPIC_L3:
      return {
        ...state,
        topicName: state.subTopicName,
        subTopicName: action.payload.topicName,
        fieldPrefix: action.payload.topicId,
        fields: [],
      };
    case types.SELECT_RESULT:
      return {
        ...state,
        fieldPrefix: action.payload.topicId,
        topicId: action.payload.topicId,
        topicName: action.payload.parentTopicName || state.topicName,
        subTopicName: action.payload.topicName,
        subject: action.payload.topicName,
      };
    case types.REQUEST_TOPIC_DATA:
      return { ...state, isLoading: true };
    case types.RECEIVE_TOPIC_DATA_ERROR:
    case types.RECEIVE_EMPTY_FIELDS:
    case types.RECEIVE_EMAIL_ERROR:
      return {
        ...state, isLoading: false, error: true, display: false,
      };
    case types.RECEIVE_FORM_FIELDS:
      return {
        ...state,
        isLoading: false,
        kanaCode: action.payload.kanaCode,
        fields: setFieldsDetail(state.fieldPrefix, action.payload.formFields),
        error: false,
        display: false,
        topicRefId: action.payload.topicRefId,
      };
    case types.REQUEST_BY_EMAIL:
      return { ...state, display: true };
    case types.PRESERVE_FIELD_DATA:
      return { ...state, fields: action.payload };
    case types.CHANGE_TOPIC:
    case types.CANCEL_EMAIL_FORM:
    case types.RECEIVE_EMAIL_RESPONSE:
    case types.LOGIN_EMAIL:
      return { ...state, display: false };
    default:
      return state;
  }
}
